import { useEffect, useState, useRef  } from "react";

import {
  Users,
  Activity,
  TrendingUp,
  AlertTriangle,
  AlertCircle,
   UserCheck,
  Undo2,
  ShoppingCart,
  Plus,
  Eye,
  RefreshCw,
  Wallet,
  DollarSign,
  Target,
} from "lucide-react";
import { motion } from "framer-motion";
import {
    PieChart,
  Pie,
  LineChart,
  Line,
  Cell,
  Treemap,
  XAxis,
  YAxis,
  ComposedChart,
  Tooltip,
  ResponsiveContainer,
  Legend,
  BarChart, Bar,
  CartesianGrid,
  ReferenceArea,
   RadialBarChart,
  RadialBar,
} from "recharts";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DateRange } from "react-date-range";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { createPortal } from "react-dom";
import { apiFetch } from "../utils/apiFetch";




import PageWrapper from "../components/PageWrapper";

export default function DashboardTraffic() {
  const chartRef = useRef(null);
  const [data, setData] = useState(null);
const [showSurveyPopup, setShowSurveyPopup] = useState(false);

const [surveyForm, setSurveyForm] = useState({
  totalVisitors: 1,
  source: "",
   customerType: "",
  firstVisit: "",
  reason: "",
});
  const [toast, setToast] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);
const [aiInsight, setAiInsight] = useState(null);
const [showAiModal, setShowAiModal] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
const [showPicker, setShowPicker] = useState(false);
  const [activeProgram, setActiveProgram] = useState(null);
  const [hourlyTrafficData, setHourlyTrafficData] = useState([]);
  const [loadingSurvey, setLoadingSurvey] = useState(false);

  const [activeBrand, setActiveBrand] = useState(null);
    const [selectedSource, setSelectedSource] = useState(null);
    const [activeDept, setActiveDept] = useState(null);
  const [deptDataApi, setDeptDataApi] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [trafficSourceData, setTrafficSourceData] = useState([]);
  const [brandDataApi, setBrandDataApi] = useState([]);
const [month, setMonth] = useState("ALL");
const [summary, setSummary] = useState(null);
const [activeLine, setActiveLine] = useState(null);
const [selectedMonth, setSelectedMonth] = useState(null);
const [chartData, setChartData] = useState([]);
const [selectedProgram, setSelectedProgram] = useState(null);
const [peakHour, setPeakHour] = useState(null);
const [pickerPos, setPickerPos] = useState({ top: 0, left: 0 });
const getThisMonthRange = () => {
  const now = new Date();

  return {
    startDate: new Date(now.getFullYear(), now.getMonth(), 1),
    endDate: now,
    key: "selection",
  };
};

const [dateRange, setDateRange] = useState([getThisMonthRange()]);
useEffect(() => {
  if (!dateRange?.[0]?.startDate || !dateRange?.[0]?.endDate) return;

  fetchChart();
  fetchSummary();
   fetchProgram();
   fetchHourlyTraffic();
   fetchBrand();
   fetchTrafficSource();
}, [dateRange]);

const fetchHourlyTraffic = async () => {
  try {
    const token = localStorage.getItem("token");
    const kode_toko = localStorage.getItem("kode_toko");

    const params = new URLSearchParams();
    params.append("start_date", formatAPIDate(startDate));
    params.append("end_date", formatAPIDate(endDate));
    params.append("kode_toko", kode_toko);
  const id_sunfish = localStorage.getItem("id_sunfish");
    params.append("id_sunfish", id_sunfish);

    const res = await apiFetch(
      `/api/traffic/traffic-hourly?${params.toString()}`,
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await res.json();

    const formatted = (json.data || []).map((item) => ({
      hour: item.hours, // dari TO_CHAR
      traffic: Number(item.traffic) || 0,
      conversion: Number(item.conversion) || 0,
    }));

    setHourlyTrafficData(formatted);
setPeakHour(getPeakHourRange(formatted));
    

  } catch (err) {
    console.log("hourly traffic error:", err);
  }
};


const kode_toko_survey =
  localStorage.getItem("kode_toko") || "";

const normalizeAI = (data) => {
  if (!data) return null;

  return {
    summary: data.summary || "",

    insights: Array.isArray(data.insights)
      ? data.insights.map((i) => {
          // string format
          if (typeof i === "string") {
            return {
              type: "text",
              text: i,
            };
          }

          // object format (metric version)
          return {
            type: "metric",
            metric: i.metric || "-",
            value: i.value ?? "-",
            text: i.interpretation || "",
            formula: i.formula || null,
          };
        })
      : [],

    recommendations: Array.isArray(data.recommendations)
      ? data.recommendations.map((r) => {
          // string format
          if (typeof r === "string") {
            return {
              type: "text",
              issue: r,
              suggestion: "",
            };
          }

          // object format (issue/suggestion)
          return {
            type: "structured",
            issue: r.issue || "",
            suggestion: r.suggestion || "",
          };
        })
      : [],
  };
};

const handleAIAnalytics = async () => {
  try {
    setAiLoading(true);
    setShowAiModal(true); // 🔥 buka popup langsung

    const payload = {
  summary: {
    flow_in: summary?.flow_in,
    customer: summary?.customer,
    employee: summary?.employee,
    turnback: summary?.turnback,
    cvr: summary?.ctr,
    revenue: summary?.net_revenue,
    transaction: summary?.total_transaksi,
    total_qty: summary?.total_qty
  }
};

    const res = await apiFetch("/api/traffic/ai-analytics", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const json = await res.json();

    if (!json.success) {
      throw new Error(json.message || "AI failed");
    }

    setAiInsight(normalizeAI(json.data));

  } catch (err) {
    console.log("AI ERROR:", err);
    setAiInsight("Gagal generate insight.");
  } finally {
    setAiLoading(false);
  }
};

const handleSubmitSurvey = async () => {
  try {

    // VALIDATION
    if (!surveyForm.customerType) {
      setToast({
        type: "error",
        message: "Pilih dulu pernah belanja atau baru",
      });
      return;
    }

    // kalau customer baru wajib isi source
    if (
      surveyForm.customerType === "Baru" &&
      !surveyForm.source
    ) {
      setToast({
        type: "error",
        message: "Pilih sumber informasi customer",
      });
      return;
    }

    if (!surveyForm.reason) {
      setToast({
        type: "error",
        message: "Pilih alasan datang",
      });
      return;
    }

    const kode_toko = localStorage.getItem("kode_toko");

    setLoadingSurvey(true);

    const payload = {
      kode_toko,

      customer_type: surveyForm.customerType,

      source:
    surveyForm.customerType === "Baru"
      ? surveyForm.source
      : "Existing Customer",

      first_visit:
        surveyForm.customerType === "Baru",

      visit_reason: surveyForm.reason,

      total_visitors: surveyForm.totalVisitors,
    };

    console.log("PAYLOAD:", payload);

    const response = await apiFetch(`/api/traffic/survey`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Gagal submit survey");
    }

    setToast({
      type: "success",
      message: "Terima kasih 🙌 Survey berhasil disimpan",
    });

    // RESET
    setSurveyForm({
      totalVisitors: 1,
      source: "",
      customerType: "",
      firstVisit: "",
      reason: "",
    });

    setShowSurveyPopup(false);

    await fetchTrafficSource();

  } catch (err) {

    console.error(err);

    setToast({
      type: "error",
      message: err.message || "Terjadi kesalahan",
    });

  } finally {

    setLoadingSurvey(false);

  }
};

const getPeakHourRange = (data) => {
  if (!data || data.length === 0) return null;

  let maxTraffic = 0;
  let peakIndex = 0;

  data.forEach((item, i) => {
    if (item.traffic > maxTraffic) {
      maxTraffic = item.traffic;
      peakIndex = i;
    }
  });

  // ambil range (1 jam sebelum & sesudah biar keliatan area)
  const start = data[Math.max(0, peakIndex - 1)]?.hour;
  const end = data[Math.min(data.length - 1, peakIndex + 1)]?.hour;

  return { start, end };
};

const formatAPIDate = (date) => {
  const d = new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const totalFlow = programData.reduce(
  (sum, item) => sum + (item.flow_value || 0),
  0
);

const startDate = dateRange[0].startDate;
const endDate = dateRange[0].endDate;

const isRangeComplete =
  dateRange?.[0]?.startDate &&
  dateRange?.[0]?.endDate &&
  dateRange?.[0]?.startDate !== dateRange?.[0]?.endDate;



const handleOpenPicker = () => {
  if (!pickerRef.current) return;

  const rect = pickerRef.current.getBoundingClientRect();

  let left = rect.left + window.scrollX;

  if (left + 600 > window.innerWidth) {
    left = window.innerWidth - 620;
  }

  setPickerPos({
    top: rect.bottom + window.scrollY + 8,
    left,
  });

  setShowPicker((prev) => !prev);
};

useEffect(() => {
  if (!toast) return;

  const timer = setTimeout(() => {
    setToast(null);
  }, 3000);

  return () => clearTimeout(timer);
}, [toast]);

useEffect(() => {
  if (programData.length > 0 && !selectedProgram) {
    setSelectedProgram(programData[0]);
  }
}, [programData]);
const formatRupiah = (num) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    }).format(num || 0);

    


const presetRanges = [
  {
    label: "Today",
    getRange: () => {
      const today = new Date();
      return { startDate: today, endDate: today };
    },
  },
  {
    label: "Last 7 Days",
    getRange: () => {
      const end = new Date();
      const start = new Date();
      start.setDate(end.getDate() - 6);
      return { startDate: start, endDate: end };
    },
  },
  {
    label: "This Month",
    getRange: () => {
      const now = new Date();
      return {
        startDate: new Date(now.getFullYear(), now.getMonth(), 1),
        endDate: now,
      };
    },
  },

  // =========================
  // 🔥 CUSTOM MONTHLY RANGE
  // =========================

  {
    label: "1 Month Ago",
    getRange: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return { startDate: start, endDate: end };
    },
  },
  {
    label: "2 Months Ago",
    getRange: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 2, 1);
      const end = new Date(now.getFullYear(), now.getMonth() - 1, 0);
      return { startDate: start, endDate: end };
    },
  },
  {
    label: "3 Months Ago",
    getRange: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 3, 1);
      const end = new Date(now.getFullYear(), now.getMonth() - 2, 0);
      return { startDate: start, endDate: end };
    },
  },
  {
    label: "4 Months Ago",
    getRange: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 4, 1);
      const end = new Date(now.getFullYear(), now.getMonth() - 3, 0);
      return { startDate: start, endDate: end };
    },
  },
];

const pickerRef = useRef();

useEffect(() => {
  const handleClickOutside = (e) => {
    const pickerEl = pickerRef.current;
    const popupEl = popupRef.current;

    if (!pickerEl || !popupEl) return;

    const isClickInsidePicker = pickerEl.contains(e.target);
    const isClickInsidePopup = popupEl.contains(e.target);

    if (!isClickInsidePicker && !isClickInsidePopup) {
      setShowPicker(false);
    }
  };

  document.addEventListener("click", handleClickOutside);

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, []);


const popupRef = useRef();
const formatDate = (date) =>
  new Intl.DateTimeFormat("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);

    const [chartSize, setChartSize] = useState({ w: 0, h: 0 });

useEffect(() => {
  if (chartRef.current) {
    const { offsetWidth, offsetHeight } = chartRef.current;
    setChartSize({ w: offsetWidth, h: offsetHeight });
  }
}, [programData]);

  const getMonthFormat = (m) => {
  if (m === "ALL") return "ALL";

  const year = new Date().getFullYear();
  return `${year}-${String(m).padStart(2, "0")}`;
};

const totalRevenue = programData.reduce(
  (acc, cur) => acc + cur.revenue,
  0
);



  const RADIAN = Math.PI / 180;

const renderNeedle = (value, total, cx, cy, iR, oR, color) => {
  const angle = 180 * (1 - value / total);
  const length = (iR + 2 * oR) / 3;

  const sin = Math.sin(-RADIAN * angle);
  const cos = Math.cos(-RADIAN * angle);

  const x0 = cx;
  const y0 = cy;

  const x1 = x0 + length * cos;
  const y1 = y0 + length * sin;

  return (
    <>
      <circle cx={x0} cy={y0} r={5} fill={color} />
      <path
        d={`M${x0},${y0} L${x1},${y1}`}
        stroke={color}
        strokeWidth={3}
      />
    </>
  );
};

const needleValue = selectedProgram?.revenue || 0;

const getMonthLabel = (m) => {
  if (m === "ALL") return "All_Months";

  const year = new Date().getFullYear();

  const monthName = new Date(0, m - 1).toLocaleString("id-ID", {
    month: "long",
  });

  return `${monthName}_${year}`;
};

const fetchProgram = async () => {
  try {
    const token = localStorage.getItem("token");
    const kode_toko = localStorage.getItem("kode_toko");

   const params = new URLSearchParams();
   params.append("start_date", formatAPIDate(startDate));
params.append("end_date", formatAPIDate(endDate));
    params.append("kode_toko", kode_toko);
      const id_sunfish = localStorage.getItem("id_sunfish");
    params.append("id_sunfish", id_sunfish);


    const res = await apiFetch(
      `/api/traffic/summary-by-age?${params.toString()}`,
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await res.json();

    const formatted = (json.data || []).map((item) => ({
      name: item.usia,
      flow_value: Number(item.flow_value || 0)
    }));

    setProgramData(formatted);

  } catch (err) {
    console.log("program error:", err);
  }
};


const exportToExcel = () => {
  const wb = XLSX.utils.book_new();

  // ================= SHEET 1: SUMMARY =================
  const summarySheet = XLSX.utils.json_to_sheet([
    {
      Month: month,
      "Total Qty": summary?.total_qty,
      "Gross Revenue": summary?.gross_revenue,
      "Net Revenue": summary?.net_revenue,
      "Transactions": summary?.total_transaksi,
      "Customer In": summary?.flow_in,
      "Conversion Rate": summary?.ctr,
      "Target Revenue": summary?.target_revenue,
    },
  ]);

  XLSX.utils.book_append_sheet(wb, summarySheet, "Summary");


  // ================= SHEET 3: BRAND =================
  const brandSheet = XLSX.utils.json_to_sheet(brandDataApi);
  XLSX.utils.book_append_sheet(wb, brandSheet, "Brand Contribution");

  // ================= SHEET 4: DEPT =================
  const deptSheet = XLSX.utils.json_to_sheet(deptDataApi);
  XLSX.utils.book_append_sheet(wb, deptSheet, "Dept Contribution");


  // ================= SHEET 6: DAILY CHART =================
  const chartSheet = XLSX.utils.json_to_sheet(chartData);
  XLSX.utils.book_append_sheet(wb, chartSheet, "Daily Traffic");


  const programSheet = XLSX.utils.json_to_sheet(programData);
XLSX.utils.book_append_sheet(wb, programSheet, "Sales by Program Acara");

  // ================= EXPORT =================
  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

 saveAs(file, `Dashboard_${getMonthLabel(month)}.xlsx`);
};



const fetchTrafficSource = async () => {
  try {
    const token = localStorage.getItem("token");
    const kode_toko = localStorage.getItem("kode_toko");

    const params = new URLSearchParams();
    params.append("start_date", formatAPIDate(startDate));
    params.append("end_date", formatAPIDate(endDate));
    params.append("kode_toko", kode_toko);
  const id_sunfish = localStorage.getItem("id_sunfish");
    params.append("id_sunfish", id_sunfish);

    const res = await apiFetch(
      `/api/traffic/summary-survey?${params.toString()}`,
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await res.json();
    const data = json.data || {};

    const formatted = [
      { name: "IG", value: Number(data.source_ig || 0) },
      { name: "TikTok", value: Number(data.source_tiktok || 0) },
      { name: "Teman", value: Number(data.source_teman || 0) },
      { name: "Komunitas", value: Number(data.source_komunitas || 0) },
      { name: "Lewat", value: Number(data.source_lewat || 0) },
      { name: "KOL", value: Number(data.source_kol || 0) },
      { name: "WA", value: Number(data.source_wa || 0) },
      { name: "Travel Driver", value: Number(data.source_travel_driver || 0) },
      { name: "Existing Customer", value: Number(data.source_existing_customer || 0) },
    ];

    setTrafficSourceData(formatted);

  } catch (err) {
    console.log("summary survey error:", err);
  }
};




const totalDept = deptDataApi.reduce((acc, cur) => acc + cur.value, 0);


 


const fetchBrand = async () => {
  try {
    const token = localStorage.getItem("token");
    const kode_toko = localStorage.getItem("kode_toko");

    const params = new URLSearchParams();
     params.append("start_date", formatAPIDate(startDate));
params.append("end_date", formatAPIDate(endDate));
    params.append("kode_toko", kode_toko);
  const id_sunfish = localStorage.getItem("id_sunfish");
    params.append("id_sunfish", id_sunfish);

    const res = await apiFetch(
      `/api/traffic/summary-gender?${params.toString()}`,
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await res.json();

    const formatted = (json.data || []).map((item) => ({
      name: item.gender,
      flow_value: Number(item.flow_value || 0), // pakai net_revenue biar lebih realistis
    
    }));

    setBrandDataApi(formatted);
  } catch (err) {
    console.log("brand error:", err);
  }
};



const handleRefresh = async () => {
  try {
    setRefreshing(true);

    await Promise.all([
      fetchChart(),
      fetchSummary(),
      fetchProgram(),
      fetchHourlyTraffic(),
      fetchTrafficSource (),
      fetchBrand(),
    ]);
  } catch (err) {
    console.log("refresh error:", err);
  } finally {
    setRefreshing(false);
  }
};

const TARGET_REVENUE = 68000000000; // 68 Miliar
const fetchChart = async () => {
  try {
    const token = localStorage.getItem("token");
    const kode_toko = localStorage.getItem("kode_toko");
    const id_sunfish = localStorage.getItem("id_sunfish");

    const params = new URLSearchParams();
   params.append("start_date", formatAPIDate(startDate));
params.append("end_date", formatAPIDate(endDate));
    params.append("kode_toko", kode_toko);
    params.append("id_sunfish", id_sunfish);

    const res = await apiFetch(
      `/api/traffic/chart-overview?${params.toString()}`,
      {
        headers: {
          "x-api-key": "SECRET123456",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const json = await res.json();

    const formatted = (json.data || []).map((item) => ({
      date: item.date?.split("T")[0], // 🔥 penting biar rapi
      revenue: Number(item.gross_revenue) || 0,
      net: Number(item.net_revenue) || 0,
      transactions: Number(item.total_transaksi) || 0,
      traffic: Number(item.flow_in) || 0,
      ctr: Number(item.ctr_percent) || 0,
    }));

    setChartData(formatted);

  } catch (err) {
    console.log("chart error:", err);
  }
};


 const fetchSummary = async () => {
      try {
        const params = new URLSearchParams();
 const token = localStorage.getItem("token");
  const kode_toko = localStorage.getItem("kode_toko");
       params.append("start_date", formatAPIDate(startDate));
params.append("end_date", formatAPIDate(endDate));
        params.append("kode_toko", kode_toko);

          const id_sunfish = localStorage.getItem("id_sunfish");
    params.append("id_sunfish", id_sunfish);


        const res = await apiFetch(
          `/api/traffic/summary-monthly?${params.toString()}`,
        {
          headers: {
            "x-api-key": "SECRET123456",
            Authorization: `Bearer ${token}`,
          },
        }
        );

        const json = await res.json();
        const rows = Array.isArray(json.data) ? json.data : [];

        const summaryObj = {
          budget: 0,
          realisasi_budget: 0,
          flow_in: 0,
          customer: 0,
          out_count: 0,
          employee: 0,
           turnback: 0,
           passby: 0,
          total_qty: 0,
          net_revenue: 0,
          gross_revenue: 0,
          target_views: 0,
          total_transaksi: 0,
          target_revenue: 0,
          total_event: 0,
          revenue: 0,
          ctr: 0,
        };

        if (rows.length > 0) {
          const row = rows[0];

          summaryObj.total_qty = Number(row.qty) || 0;
          summaryObj.net_revenue = Number(row.net_revenue) || 0;
          summaryObj.gross_revenue = Number(row.gross_revenue) || 0;
          summaryObj.total_transaksi = Number(row.total_transaksi) || 0;
          summaryObj.revenue = Number(row.revenue) || 0;
          summaryObj.target_revenue = Number(row.target_revenue) || 0;
          summaryObj.flow_in = Number(row.flow_in) || 0;
          summaryObj.customer = Number(row.customer) || 0;
          summaryObj.out_count = Number(row.out_count) || 0;
          summaryObj.employee = Number(row.employee) || 0;
          summaryObj.turnback = Number(row.turnback) || 0;
          summaryObj.passby = Number(row.passby) || 0;
          summaryObj.ctr = Number(row.ctr_percent) || 0;
          summaryObj.total_event = Number(row.total_event) || 0;

          summaryObj.sisa =
            summaryObj.budget - summaryObj.realisasi_budget;
        }

        setSummary(summaryObj);
      } catch (err) {
        console.error("fetchSummary error:", err);
      }
    };

const getProgressColor = (val) => {
  if (val < 50) return "bg-red-500";
  if (val < 80) return "bg-yellow-500";
  return "bg-green-500";
};
const isCpvHigh = summary && summary.cpv > 15;
const achievement =
  summary && summary.target_views > 0
    ? (summary.views / summary.target_views) * 100
    : 0;

const safeAchievement = Math.min(achievement, 100);

// 🔥 dependency

const targetRevenueAchievement =
  summary && summary.target_revenue > 0
    ? (summary.net_revenue / summary.target_revenue) * 100
    : 0;

const safeTargetRevenueAchievement = Math.min(targetRevenueAchievement, 100);

const getBudgetColor = (val) => {
  if (val < 50) return "bg-yellow-500"; // masih aman
  if (val < 90) return "bg-green-500";  // ideal
  return "bg-red-500"; // hampir habis
};

const cx = chartSize.w * 0.5;
const cy = chartSize.h * 0.55;

const getViewsColor = (val) => {
  if (val < 50) return "bg-red-100 text-red-600";     // jauh dari target
  if (val < 80) return "bg-yellow-100 text-yellow-600"; // mendekati
  return "bg-green-100 text-green-600";               // bagus
};



const getViewsIcon = (val) => {
  if (val < 50) return AlertCircle;
  if (val < 80) return Eye;
  return TrendingUp;
};

const getRevenueColor = (val) => {
  if (val < 50) return "bg-red-500";
  if (val < 80) return "bg-yellow-500";
  return "bg-green-500";
};

const bgColors = [
  "bg-blue-50",
  "bg-rose-50",
  "bg-yellow-50",
  "bg-indigo-50",
  "bg-green-50",
  "bg-purple-50",
];



console.log("ACH:", safeTargetRevenueAchievement);
console.log("SUMMARY:", summary);

const getConversionColor = (val) => {
  if (val < 50) return "from-red-500 to-red-600";
  if (val < 80) return "from-yellow-400 to-yellow-500";
  return "from-green-500 to-emerald-500";
};

const CONVERSION_TARGET = 20;

const conversionAchievement =
  summary?.ctr > 0
    ? (summary.ctr / CONVERSION_TARGET) * 100
    : 0;

const safeConversionAchievement = Math.min(conversionAchievement, 100);

const stats = [
  {
    label: "Traffic",
    value: summary ? summary.flow_in.toLocaleString("id-ID") : "0",
    subValue: summary
      ? `${summary.total_event || 0} events running (Jumlah traffic yang melintas masuk pintu, termasuk karyawan dan tamu)`
      : "",
    icon: Eye,
    color: "from-indigo-500 to-blue-500",
  },

  {
    label: "Customers",
    value: summary ? summary.customer.toLocaleString("id-ID") : "0",
    subValue:
      "Jumlah traffic yang dihitung setelah dikurangi karyawan & tamu",
    icon: Users,
    color: "from-cyan-500 to-blue-500",
  },

  {
    label: "Turnback",
    value: summary ? summary.turnback.toLocaleString("id-ID") : "0",
    subValue:
      "Jumlah traffic yang dianggap tidak jadi atau masuk < 60 detik",
    icon: Undo2,
    color: "from-orange-500 to-red-500",
  },

  {
    label: "Karyawan",
    value: summary ? summary.employee.toLocaleString("id-ID") : "0",
    subValue:
      "Jumlah traffic karyawan yang memakai tag standard",
    icon: UserCheck,
    color: "from-violet-500 to-purple-500",
  },

  {
    label: "Transaction",
    value: summary
      ? summary.total_transaksi.toLocaleString("id-ID")
      : "0",
    subValue: summary
      ? `Dari ${summary.customer.toLocaleString("id-ID")} customer`
      : "",
    icon: ShoppingCart,
    color:
      summary?.total_transaksi >= summary?.target_trx * 0.8
        ? "from-green-500 to-emerald-500"
        : summary?.total_transaksi >= summary?.target_trx * 0.5
        ? "from-yellow-400 to-yellow-500"
        : "from-red-500 to-red-600",
    percent:
      summary?.target_trx > 0
        ? Math.min(
            (summary.total_transaksi / summary.target_trx) * 100,
            100
          )
        : undefined,
  },

  {
    label: "Conversion Rate",
    value: summary ? `${summary.ctr.toFixed(2)}%` : "0",
    subValue: summary
      ? `${formatRupiah(summary.net_revenue) || 0} revenue`
      : "",
    icon: Target,
    color: getConversionColor(safeConversionAchievement),
    percent: safeConversionAchievement,
  },
];

const totalBrand = brandDataApi.reduce((acc, cur) => acc + cur.value, 0);


const deptData = [
  { name: "Men", value: 220000000 },
  { name: "Women", value: 180000000 },
  { name: "Kids", value: 90000000 },
];

const COLORS = [
  "#6366f1",
  "#3b82f6",
  "#06b6d4",
  "#22c55e",
  "#f59e0b",
  "#ef4444",
];


  return (
    <PageWrapper>

  {/* HEADER */}
<div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-3">

  {/* LEFT */}
  <div>
    <h1 className="text-lg md:text-xl font-semibold text-gray-800">
      Store Traffic Overview
    </h1>
    <p className="text-xs text-gray-500">
      Monitor people counting system by Foorir
    </p>
  </div>

  {/* RIGHT ACTIONS */}
  <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full lg:w-auto">

    {/* DATE PICKER */}
    <div className="relative w-full sm:w-auto" ref={pickerRef}>

      <div
        onClick={handleOpenPicker}
        className="flex items-center gap-2 border rounded-xl px-3 md:px-4 py-2 text-sm bg-white cursor-pointer shadow-sm hover:shadow-md transition w-full sm:w-auto"
      >
        <span className="text-gray-500 shrink-0">📅</span>

        <span className="font-medium text-gray-700 truncate">
          {formatDate(dateRange[0].startDate)} -{" "}
          {formatDate(dateRange[0].endDate)}
        </span>
      </div>

      {/* DROPDOWN */}
      {showPicker &&
        createPortal(
          <div
            ref={popupRef}
            onClick={(e) => e.stopPropagation()}
            className="fixed z-[9999] bg-white border rounded-2xl shadow-2xl p-4 flex gap-4 max-w-[95vw]"
            style={{
              top: pickerPos.top,
              left: pickerPos.left,
            }}
          >
            {/* PRESET */}
            <div className="flex flex-col gap-2 pr-3 border-r">
              {presetRanges.map((p, i) => (
                <button
                  key={i}
                  onClick={() => {
                    const range = p.getRange();
                    setDateRange([{ ...range, key: "selection" }]);
                    setShowPicker(false);
                  }}
                  className="text-left px-3 py-2 text-sm rounded-lg hover:bg-indigo-50 text-gray-600 hover:text-indigo-600 transition"
                >
                  {p.label}
                </button>
              ))}
            </div>

            {/* CALENDAR */}
            <DateRange
              editableDateInputs={false}
              onChange={(item) => setDateRange([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              rangeColors={["#4f46e5"]}
            />
          </div>,
          document.body
        )}
    </div>

    {/* ACTION BUTTONS */}
   {/* ACTION BUTTONS */}
<div className="flex gap-2 w-full sm:w-auto">

  {/* REFRESH */}
  <button
    onClick={handleRefresh}
    disabled={refreshing}
    className="flex-1 sm:flex-none px-3 py-2 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700 transition flex items-center justify-center disabled:opacity-50"
  >
    <RefreshCw
      size={16}
      className={refreshing ? "animate-spin" : ""}
    />
  </button>

  {/* AI ANALYTICS */}
  <button
    onClick={handleAIAnalytics}
    disabled={aiLoading}
    className="
      flex-1 sm:flex-none
      px-4 py-2
      rounded-lg
      bg-gradient-to-r
      from-violet-600
      to-indigo-600
      text-white
      text-sm
      font-medium
      hover:opacity-90
      transition
      disabled:opacity-50
    "
  >
    {aiLoading
      ? "Analyzing..."
      : "🤖 AI Analytics"}
  </button>

  {/* EXPORT */}
  <button
    onClick={exportToExcel}
    className="flex-1 sm:flex-none px-3 py-2 bg-indigo-600 text-white text-sm rounded-lg hover:bg-indigo-700 transition"
  >
    Export Excel
  </button>

</div>

  </div>

</div>

      {/* STATS */}
     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-5">

  {stats.map((s, i) => {
    const Icon = s.icon;

    return (
     <div
  key={i}
  className={`group border border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all duration-300 ${bgColors[i % bgColors.length]}`}
>

        {/* HEADER */}
        <div className="flex items-start justify-between">
          
          <div>
            <p className="text-xs text-gray-400 uppercase tracking-wide">
              {s.label}
            </p>

            <h2 className="text-lg md:text-xl font-semibold text-gray-900 tracking-tight mt-1">
  {s.value}
</h2>

            {s.subValue && (
              <p className="text-xs text-gray-400 mt-1">
                {s.subValue}
              </p>
            )}
          </div>

          {/* ICON BADGE */}
          <div
            className={`p-3 rounded-xl bg-gradient-to-br ${s.color} text-white shadow-md group-hover:scale-110 transition`}
          >
            <Icon size={20} />
          </div>

        </div>

        {/* WARNING */}
        {s.warning && (
          <div className="mt-3 text-xs text-red-500 flex items-center gap-1">
            <AlertCircle size={14} />
            CPV terlalu tinggi
          </div>
        )}

        {/* PROGRESS */}
        {s.percent !== undefined && (
          <div className="mt-4">

            <div className="flex justify-between text-xs text-gray-400 mb-1">
              <span>Progress</span>
              <span className="font-medium text-gray-600">
                {s.percent.toFixed(1)}%
              </span>
            </div>

            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full bg-gradient-to-r ${s.color} transition-all duration-500`}
                style={{ width: `${s.percent}%` }}
              />
            </div>

          </div>
        )}

      </div>
    );
  })}

</div>

      {/* MAIN GRID */}
     <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-6">

        {/* LEFT - CHART MOCK */}
   <div className="bg-white p-6 rounded-2xl border shadow-sm hover:shadow-md transition-all duration-300">

  <h3 className="text-sm font-semibold text-gray-700 mb-4 tracking-wide">
    Daily Traffic Overview
  </h3>

  <ResponsiveContainer width="100%" height={350}>
    <LineChart
  data={chartData}
  margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
   animationDuration={1200}
  animationEasing="ease-out"
>

      <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" />

      <XAxis
        dataKey="date"
        tick={{ fontSize: 11, fill: "#94a3b8" }}
        tickFormatter={(v) => v.slice(5)}
        axisLine={false}
        tickLine={false}
      />

      <YAxis
        yAxisId="left"
        tick={{ fontSize: 11, fill: "#94a3b8" }}
        axisLine={false}
        tickLine={false}
      />

      <YAxis
        yAxisId="right"
        orientation="right"
        tick={{ fontSize: 11, fill: "#94a3b8" }}
        axisLine={false}
        tickLine={false}
      />

      <Tooltip
  cursor={{ stroke: "#e2e8f0", strokeWidth: 1 }}
  contentStyle={{
    backgroundColor: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    fontSize: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.05)"
  }}
/>

      <Legend wrapperStyle={{ fontSize: 12 }} />

      {/* TRANSACTIONS */}
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="transactions"
        dot={false}
          animationDuration={800}
  animationEasing="ease-out"
   activeDot={{ r: 6, strokeWidth: 2 }}
    stroke={activeLine === "transactions" ? "#2563eb" : "#93c5fd"}
  strokeWidth={activeLine === "transactions" ? 3 : 2}
  onMouseEnter={() => setActiveLine("transactions")}
  onMouseLeave={() => setActiveLine(null)}
      />

      {/* TRAFFIC */}
      <Line
        yAxisId="left"
        type="monotone"
        dataKey="traffic"
        stroke="#10b981"
        strokeWidth={2}
        dot={false}
          animationDuration={800}
  animationEasing="ease-out"
   activeDot={{ r: 6, strokeWidth: 2 }}
      />

      {/* CTR */}
      <Line
        yAxisId="right"
        type="monotone"
        dataKey="ctr"
        stroke="#f59e0b"
        strokeWidth={2}
        dot={false}
          animationDuration={800}
  animationEasing="ease-out"
   activeDot={{ r: 6, strokeWidth: 2 }}
      />

    </LineChart>
  </ResponsiveContainer>

</div>
        {/* RIGHT - ACTIVITY */}
 <div className="bg-white p-6 rounded-2xl border shadow-sm hover:shadow-md transition relative">

  {/* HEADER */}
  <h3 className="text-sm font-semibold text-gray-700 mb-4 tracking-wide">
    Traffic Today (Hourly)
  </h3>

  {/* POWER HOURS BADGE */}
  <div className="absolute top-4 right-4 bg-white border shadow-md rounded-xl px-4 py-3">

    <div className="text-gray-500 text-xs mb-1">
      Power Hour Peak
    </div>

    <div className="text-green-500 font-bold text-xl leading-none">
     {peakHour ? `${peakHour.start} - ${peakHour.end}` : "-"}
    </div>

  </div>

  {/* CHART */}
  <div className="h-[340px]">

    <ResponsiveContainer width="100%" height="100%">
  <LineChart
    data={hourlyTrafficData}
    margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
  >

    <CartesianGrid stroke="#f1f5f9" strokeDasharray="3 3" />

    {/* X AXIS (Jam) */}
    <XAxis
      dataKey="hour"
      tick={{ fontSize: 11, fill: "#94a3b8" }}
      axisLine={false}
      tickLine={false}
    />

    {/* LEFT Y AXIS = TRAFFIC */}
    <YAxis
      yAxisId="left"
      tick={{ fontSize: 11, fill: "#94a3b8" }}
      axisLine={false}
      tickLine={false}
    />

    {/* RIGHT Y AXIS = CONVERSION % */}
    <YAxis
      yAxisId="right"
      orientation="right"
      tick={{ fontSize: 11, fill: "#94a3b8" }}
      axisLine={false}
      tickLine={false}
      tickFormatter={(v) => `${v}%`}
    />

    <Tooltip
      contentStyle={{
        borderRadius: 12,
        border: "1px solid #e5e7eb",
        fontSize: 12,
      }}
      formatter={(value, name) => {
        if (name === "conversion") return [`${value}%`, "Conversion"];
        return [`${value} Customer in`, "Customer in"];
      }}
    />

    <Legend wrapperStyle={{ fontSize: 12 }} />

    {/* 🔥 POWER HOUR HIGHLIGHT */}
   
   {peakHour && (
  <ReferenceArea
    x1={peakHour.start}
    x2={peakHour.end}
    fill="rgba(59,130,246,0.08)"
    strokeOpacity={0}
  />
)}

    {/* LABEL PEAK HOUR */}
    {peakHour && (
  <ReferenceArea
    x1={peakHour.start}
    x2={peakHour.end}
    fill="transparent"
    label={{
      value: "Peak Hour",
      position: "insideTop",
      fill: "#2563eb",
      fontSize: 12,
      fontWeight: 600,
    }}
  />
)}

    {/* 🔵 TRAFFIC LINE */}
    <Line
      yAxisId="left"
      type="monotone"
      dataKey="traffic"
      stroke="#3b82f6"
      strokeWidth={3}
      dot={{ r: 3 }}
      activeDot={{ r: 6 }}
    />

    {/* 🟢 CONVERSION LINE */}
    <Line
      yAxisId="right"
      type="monotone"
      dataKey="conversion"
      stroke="#10b981"
      strokeWidth={3}
      dot={{ r: 3 }}
      activeDot={{ r: 6 }}
    />

  </LineChart>
</ResponsiveContainer>
  </div>

</div>

      </div>

      {/* QUICK ACTIONS */}
      {/* QUICK ACTIONS + INSIGHT SPLIT */}

      {/* AI INSIGHT */}


<div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">

<div className="space-y-4">
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

  {/* ================= CARD 1: CHART ================= */}
 <div className="bg-white p-4 rounded-2xl border shadow-sm h-[360px] flex flex-col">

  {/* HEADER */}
  <div className="flex items-center justify-between mb-4">
    <h3 className="font-semibold text-gray-700">
      Traffic Trend by Age
    </h3>
    <span className="text-[10px] text-gray-400">
      Age distribution
    </span>
  </div>

  {programData.length === 0 ? (
    <div className="h-[250px] flex items-center justify-center text-sm text-gray-400">
      No age data available
    </div>
  ) : (

    <div className="w-full h-[260px] relative">

    <ResponsiveContainer width="100%" height="100%">
  <PieChart>
    
    <Pie
      data={programData}
      dataKey="flow_value"
      nameKey="name"
      cx="50%"
      cy="50%"
      outerRadius="80%"
      innerRadius="40%" // kalau mau donut
      paddingAngle={3}
      stroke="#000"
      strokeWidth={1}
      isAnimationActive={true}
      animationDuration={300}
    >
      {programData.map((entry, index) => (
        <Cell
          key={`cell-${index}`}
          fill={COLORS[index % COLORS.length]}
        />
      ))}
    </Pie>

    <Tooltip
      formatter={(v) =>
        `${(v ?? 0).toLocaleString("id-ID")} customers`
      }
      contentStyle={{
        fontSize: "11px",
        borderRadius: "10px",
      }}
    />

  </PieChart>
</ResponsiveContainer>

      {/* 🔥 CENTER INFO */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">

        <div className="text-xs text-gray-400">
          Total Traffic
        </div>

        <div className="text-lg font-semibold text-gray-700">
          {(totalFlow ?? 0).toLocaleString("id-ID")}
        </div>

      </div>

    </div>
  )}

</div>

  {/* ================= CARD 2: LIST ================= */}
  <div className="bg-white p-4 rounded-2xl  border shadow-sm">

  <h3 className="font-semibold text-gray-700 mb-3">
    Age Breakdown
  </h3>

  {programData.length === 0 ? (
    <div className="text-center text-sm text-gray-400 py-6">
      No age data available
    </div>
  ) : (
   <div className="mt-3 flex-1 overflow-y-auto pr-1 space-y-2 max-h-[260px]">

  {[...programData]
  .sort((a, b) => (b.flow_value ?? 0) - (a.flow_value ?? 0))
  .map((item, i) => {
    const isActive = selectedProgram?.name === item.name;
    const percent =
      totalFlow > 0
        ? (item.flow_value / totalFlow) * 100
        : 0;

    return (
      <div
        key={i}
        onClick={() => setSelectedProgram(item)}
        className={`
          flex items-center justify-between px-3 py-2 rounded-xl cursor-pointer
          transition
          ${isActive ? "bg-indigo-50 ring-1 ring-indigo-200" : "hover:bg-gray-50"}
        `}
      >

        {/* LEFT */}
        <div className="flex flex-col w-full mr-3">

          {/* TITLE + COLOR */}
          <div className="flex items-center gap-2">

            <span
              className="w-3 h-3 rounded-md shadow-sm"
              style={{ background: COLORS[i % COLORS.length] }}
            />

            <span className="text-sm text-gray-700 font-medium">
             Usia {item.name}
            </span>

          </div>

          {/* SUB INFO (FLOW) */}
          <div className="text-[11px] text-gray-400 mt-0.5">
            {(item.flow_value ?? 0).toLocaleString("id-ID")} customers
          </div>

          {/* MINI BAR */}
          <div className="mt-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">

            <div
              className="h-full rounded-full transition-all duration-500"
              style={{
                width: `${percent}%`,
                background: COLORS[i % COLORS.length],
              }}
            />

          </div>

        </div>

        {/* RIGHT */}
        <div className="text-right whitespace-nowrap">

          <div className="text-xs font-semibold text-gray-700">
            {(item.flow_value ?? 0).toLocaleString("id-ID")} customers
          </div>

          <div className="text-[10px] text-gray-400">
            {percent.toFixed(1)}%
          </div>

        </div>

      </div>
    );
  })}

</div>
  )}

</div>

</div>
</div>


<div className="space-y-4">
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

  {/* ================= CARD 1: CHART ================= */}
 <div className="bg-white p-4 rounded-2xl border shadow-sm h-[360px] flex flex-col">

  {/* HEADER */}
  <div className="flex items-center justify-between mb-4">
    <h3 className="font-semibold text-gray-700">
      Traffic Trend by Gender
    </h3>
    <span className="text-[10px] text-gray-400">
      Gender distribution
    </span>
  </div>

  {brandDataApi.length === 0 ? (
    <div className="h-[250px] flex items-center justify-center text-sm text-gray-400">
      No Gender data available
    </div>
  ) : (

    <div className="w-full h-[260px] relative">

    <ResponsiveContainer width="100%" height="100%">
  <PieChart>
    
    <Pie
      data={brandDataApi}
      dataKey="flow_value"
      nameKey="name"
      cx="50%"
      cy="50%"
      outerRadius="80%"
      innerRadius="40%" // kalau mau donut
      paddingAngle={3}
      stroke="#000"
      strokeWidth={1}
      isAnimationActive={true}
      animationDuration={300}
    >
      {brandDataApi.map((entry, index) => (
        <Cell
          key={`cell-${index}`}
          fill={COLORS[index % COLORS.length]}
        />
      ))}
    </Pie>

    <Tooltip
      formatter={(v) =>
        `${(v ?? 0).toLocaleString("id-ID")} customers`
      }
      contentStyle={{
        fontSize: "11px",
        borderRadius: "10px",
      }}
    />

  </PieChart>
</ResponsiveContainer>

      {/* 🔥 CENTER INFO */}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">

        <div className="text-xs text-gray-400">
          Total Traffic
        </div>

        <div className="text-lg font-semibold text-gray-700">
          {(totalFlow ?? 0).toLocaleString("id-ID")}
        </div>

      </div>

    </div>
  )}

</div>

  {/* ================= CARD 2: LIST ================= */}
  <div className="bg-white p-4 rounded-2xl  border shadow-sm">

  <h3 className="font-semibold text-gray-700 mb-3">
    Gender Breakdown
  </h3>

  {brandDataApi.length === 0 ? (
    <div className="text-center text-sm text-gray-400 py-6">
      No gender data available
    </div>
  ) : (
   <div className="mt-3 flex-1 overflow-y-auto pr-1 space-y-2 max-h-[260px]">

  {[...brandDataApi]
  .sort((a, b) => (b.flow_value ?? 0) - (a.flow_value ?? 0))
  .map((item, i) => {
    const isActive = selectedProgram?.name === item.name;
    const percent =
      totalFlow > 0
        ? (item.flow_value / totalFlow) * 100
        : 0;

    return (
      <div
        key={i}
        onClick={() => setSelectedProgram(item)}
        className={`
          flex items-center justify-between px-3 py-2 rounded-xl cursor-pointer
          transition
          ${isActive ? "bg-indigo-50 ring-1 ring-indigo-200" : "hover:bg-gray-50"}
        `}
      >

        {/* LEFT */}
        <div className="flex flex-col w-full mr-3">

          {/* TITLE + COLOR */}
          <div className="flex items-center gap-2">

            <span
              className="w-3 h-3 rounded-md shadow-sm"
              style={{ background: COLORS[i % COLORS.length] }}
            />

            <span className="text-sm text-gray-700 font-medium">
              {item.name}
            </span>

          </div>

          {/* SUB INFO (FLOW) */}
          <div className="text-[11px] text-gray-400 mt-0.5">
            {(item.flow_value ?? 0).toLocaleString("id-ID")} customers
          </div>

          {/* MINI BAR */}
          <div className="mt-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">

            <div
              className="h-full rounded-full transition-all duration-500"
              style={{
                width: `${percent}%`,
                background: COLORS[i % COLORS.length],
              }}
            />

          </div>

        </div>

        {/* RIGHT */}
        <div className="text-right whitespace-nowrap">

          <div className="text-xs font-semibold text-gray-700">
            {(item.flow_value ?? 0).toLocaleString("id-ID")} customers
          </div>

          <div className="text-[10px] text-gray-400">
            {percent.toFixed(1)}%
          </div>

        </div>

      </div>
    );
  })}

</div>
  )}

</div>

</div>
</div>


<div className="space-y-4">
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    {/* ================= CARD 1 ================= */}
    <div className="bg-white p-4 rounded-2xl border shadow-sm h-[360px] flex flex-col">

      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-700">
          Traffic by Source
        </h3>
        <span className="text-[10px] text-gray-400">
          Customer acquisition source
        </span> 
      </div>

      {trafficSourceData.length === 0 ? (
        <div className="h-[250px] flex items-center justify-center text-sm text-gray-400">
          No traffic source data available
        </div>
      ) : (
        <div className="w-full h-[260px] relative">

          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={trafficSourceData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius="80%"
                innerRadius="40%"
                paddingAngle={3}
                stroke="#000"
                strokeWidth={1}
              >
                {trafficSourceData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>

              <Tooltip
                formatter={(v) =>
                  `${(v ?? 0).toLocaleString("id-ID")} visitors`
                }
              />
            </PieChart>
          </ResponsiveContainer>

          {/* CENTER */}
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <div className="text-xs text-gray-400">Total Traffic</div>
            <div className="text-lg font-semibold text-gray-700">
              {trafficSourceData.reduce((a, b) => a + b.value, 0).toLocaleString("id-ID")}
            </div>
          </div>

        </div>
      )}
    </div>

    {/* ================= CARD 2 ================= */}
    <div className="bg-white p-4 rounded-2xl border shadow-sm">

      <h3 className="font-semibold text-gray-700 mb-3">
        Traffic Source Breakdown
      </h3>

      {trafficSourceData.length === 0 ? (
        <div className="text-center text-sm text-gray-400 py-6">
          No traffic source data available
        </div>
      ) : (
        <div className="mt-3 space-y-2 max-h-[260px] overflow-y-auto pr-1">

          {[...trafficSourceData]
            .sort((a, b) => b.value - a.value)
            .map((item, i) => {

              const total = trafficSourceData.reduce((a, b) => a + b.value, 0);
              const percent = total > 0 ? (item.value / total) * 100 : 0;

              return (
                <div key={i} className="flex justify-between items-center px-3 py-2 rounded-xl hover:bg-gray-50">

                  <div className="flex items-center gap-2">
                    <span
                      className="w-3 h-3 rounded-md"
                      style={{ background: COLORS[i % COLORS.length] }}
                    />
                    <div>
                      <div className="text-sm font-medium">{item.name}</div>
                      <div className="text-[11px] text-gray-400">
                        {item.value.toLocaleString("id-ID")} visitors
                      </div>
                    </div>
                  </div>

                  <div className="text-right">
                    <div className="text-xs font-semibold">
                      {percent.toFixed(1)}%
                    </div>
                  </div>

                </div>
              );
            })}

        </div>
      )}

    </div>

  </div>
</div>

  {/* RIGHT - SALES PERFORMANCE INDIVIDUAL */}


</div>

      {/* RAW API DEBUG (OPTIONAL) */}
      <div className="mt-6 bg-gray-50 p-4 rounded-xl border text-xs text-gray-500">
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </div>

      {/* FLOATING SURVEY BUTTON */}
{/* FLOATING SURVEY BUTTON */}
<div className="fixed bottom-6 right-6 z-[9999]">

  {/* POPUP */}
  {showSurveyPopup && (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0 }}
      className="absolute bottom-16 right-0 w-[360px] bg-white rounded-3xl shadow-2xl border overflow-hidden"
    >

      {/* HEADER */}
      <div className="bg-gradient-to-r from-indigo-600 to-blue-500 p-5 text-white">
        <h3 className="font-semibold text-lg">
          Customer Survey
        </h3>

        <p className="text-xs text-indigo-100 mt-1">
          Bantu kami memahami customer lebih baik
        </p>
      </div>

      {/* BODY */}
      <div className="p-5 space-y-5 max-h-[75vh] overflow-y-auto">

        {/* TOTAL VISITORS */}
        <div>
          <label className="text-sm font-semibold text-gray-700 block mb-2">
            Jumlah Pengunjung Dalam Rombongan
          </label>

          <div className="flex items-center gap-3">

            <button
              onClick={() =>
                setSurveyForm((prev) => ({
                  ...prev,
                  totalVisitors: Math.max(1, prev.totalVisitors - 1),
                }))
              }
              className="w-10 h-10 rounded-xl border flex items-center justify-center hover:bg-gray-50"
            >
              -
            </button>

            <div className="flex-1 h-10 rounded-xl border flex items-center justify-center font-semibold text-lg">
              {surveyForm.totalVisitors}
            </div>

            <button
              onClick={() =>
                setSurveyForm((prev) => ({
                  ...prev,
                  totalVisitors: prev.totalVisitors + 1,
                }))
              }
              className="w-10 h-10 rounded-xl border flex items-center justify-center hover:bg-gray-50"
            >
              +
            </button>

          </div>

          <p className="text-xs text-gray-400 mt-2">
            Total orang yang datang bersama customer ini
          </p>
        </div>

        {/* QUESTION 1 */}
       {/* QUESTION 1 */}
<div>
  <label className="text-sm font-semibold text-gray-700 block mb-3">
    1. Pernah belanja di 3Second?
  </label>

  <div className="space-y-2">
    {["Pernah", "Baru"].map((item) => (
      <label
        key={item}
        className="flex items-center gap-3 text-sm text-gray-600"
      >
        <input
          type="radio"
          name="customer_type"
          checked={surveyForm.customerType === item}
          onChange={() =>
            setSurveyForm((prev) => ({
              ...prev,
              customerType: item,
              source: "", // reset source saat ganti pilihan
            }))
          }
          className="accent-indigo-600"
        />
        {item}
      </label>
    ))}
  </div>
</div>

{/* QUESTION 2 - ONLY IF BARU */}
{surveyForm.customerType === "Baru" && (
  <div>
    <label className="text-sm font-semibold text-gray-700 block mb-3">
      2. Tahu acara/toko ini dari mana?
    </label>

    <div className="space-y-2">
      {[
        "IG",
        "TikTok",
        "Teman",
        "Komunitas",
        "Lewat",
        "KOL",
        "WA",
        "Travel Driver",
      ].map((item) => (
        <label
          key={item}
          className="flex items-center gap-3 text-sm text-gray-600"
        >
          <input
            type="radio"
            name="source"
            checked={surveyForm.source === item}
            onChange={() =>
              setSurveyForm((prev) => ({
                ...prev,
                source: item,
              }))
            }
            className="accent-indigo-600"
          />
          {item}
        </label>
      ))}
    </div>
  </div>
)}

        {/* QUESTION 3 */}
        <div>
          <label className="text-sm font-semibold text-gray-700 block mb-3">
            3. Datang karena:
          </label>

          <div className="space-y-2">
            {[
              "Event",
              "Promo",
              "Kebutuhan",
              
            ].map((item) => (
              <label
                key={item}
                className="flex items-center gap-3 text-sm text-gray-600"
              >
                <input
                  type="radio"
                  name="reason"
                  checked={surveyForm.reason === item}
                  onChange={() =>
                    setSurveyForm((prev) => ({
                      ...prev,
                      reason: item,
                    }))
                  }
                  className="accent-indigo-600"
                />
                {item}
              </label>
            ))}
          </div>
        </div>

        {/* COPY LINK SURVEY */}
<div className="border rounded-2xl p-3 bg-gray-50">

  <label className="text-sm font-semibold text-gray-700 block mb-2">
    Link Survey Mobile
  </label>

  <div className="flex gap-2">

    <input
      type="text"
      readOnly
      value={`https://bmc.biensicore.com/survey/${kode_toko_survey}`}
      className="
        flex-1 px-3 py-2 rounded-xl border
        bg-white text-sm text-gray-600
      "
    />

    <button
      onClick={() => {
        navigator.clipboard.writeText(
          `https://bmc.biensicore.com/survey/${kode_toko_survey}`
        );

        alert("Link berhasil dicopy");
      }}
      className="
        px-4 rounded-xl
        bg-indigo-600 text-white text-sm
        hover:bg-indigo-700 transition
      "
    >
      Copy
    </button>

  </div>

</div>

        {/* ACTION */}
        <div className="flex gap-3 pt-2">

          <button
            onClick={() => setShowSurveyPopup(false)}
            className="flex-1 py-2.5 rounded-xl border text-gray-600 hover:bg-gray-50 transition"
          >
            Tutup
          </button>

         <button
  onClick={handleSubmitSurvey}
  disabled={loadingSurvey}
  className="
    flex-1 py-2.5 rounded-xl
    bg-indigo-600 text-white
    hover:bg-indigo-700
    transition font-medium
    disabled:opacity-50
  "
>
  {loadingSurvey ? "Menyimpan..." : "Simpan"}
</button>

        </div>

      </div>
    </motion.div>
  )}

  {/* FLOAT BUTTON */}
<motion.button
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.96 }}
  onClick={() => setShowSurveyPopup((prev) => !prev)}
  className="
    flex items-center gap-3
    px-5 py-3
    rounded-full
    bg-gradient-to-r from-indigo-600 to-blue-500
    text-white
    shadow-2xl
    hover:shadow-indigo-300/50
    transition-all
  "
>

  {/* ICON */}
  <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
    <Plus size={18} />
  </div>

  {/* TEXT */}
  <div className="text-left leading-tight">

    <div className="text-sm font-semibold">
      Survey 15 Detik
    </div>

    <div className="text-[11px] text-indigo-100">
      Bantu improve experience
    </div>

  </div>

</motion.button>

</div>

{toast && (
  <div
    className={`
      fixed top-5 right-5 z-[99999]
      px-4 py-3 rounded-xl shadow-lg text-white
      transition-all
      ${toast.type === "success" ? "bg-green-500" : "bg-red-500"}
    `}
  >
    <div className="flex items-center gap-2">
      {toast.type === "success" ? "✅" : "⚠️"}
      <span className="text-sm">{toast.message}</span>
    </div>
  </div>
)}


{showAiModal && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
    
    <div className="bg-white w-[90%] max-w-xl rounded-2xl shadow-xl p-6 relative">

      {/* CLOSE */}
      <button
        onClick={() => setShowAiModal(false)}
        className="absolute top-3 right-3 text-gray-400 hover:text-black"
      >
        ✕
      </button>

     <div className="flex items-center justify-between mb-4">
  <h2 className="text-lg font-semibold">
    🤖 AI Analytics Insight
  </h2>

  <span className="text-xs px-2 py-1 bg-green-100 text-green-600 rounded-full">
    Live Analysis
  </span>
</div>

      {/* LOADING */}
      {aiLoading ? (
        <div className="flex flex-col items-center py-10">
          <div className="animate-spin rounded-full h-10 w-10 border-4 border-indigo-500 border-t-transparent"></div>
          <p className="text-sm text-gray-500 mt-3">
            Generating insight...
          </p>
        </div>
      ) : (
        <div className="text-sm text-gray-700 whitespace-pre-line leading-relaxed">
          <div className="space-y-5 text-sm">

  {/* SUMMARY */}
  <div>
    <h3 className="font-semibold text-gray-800 mb-1">📊 Summary</h3>
    <p className="text-gray-600 leading-relaxed">
      {aiInsight?.summary}
    </p>
  </div>

  {/* INSIGHTS */}
<div>
  <h3 className="font-semibold text-gray-800 mb-2">
    🔎 Key Insights
  </h3>

  <div className="space-y-2">
    {aiInsight?.insights?.map((item, i) => (
      <div key={i} className="p-3 bg-gray-50 rounded-lg border">

        {item.type === "metric" ? (
          <>
            <div className="flex justify-between">
              <span className="text-xs text-indigo-600 font-semibold uppercase">
                {item.metric}
              </span>
              <span className="font-bold">{item.value}</span>
            </div>

            <p className="text-xs text-gray-600 mt-1">
              {item.comment}
            </p>

            {item.formula && (
              <p className="text-[10px] text-gray-400">
                {item.formula}
              </p>
            )}
          </>
        ) : (
          <p className="text-sm text-gray-700">
            {item.text}
          </p>
        )}

      </div>
    ))}
  </div>
</div>

  {/* RECOMMENDATIONS */}
<div>
  <h3 className="font-semibold text-gray-800 mb-2">
    🚀 Recommendations
  </h3>

  <div className="space-y-3">
    {aiInsight?.recommendations?.map((item, i) => (
      <div key={i} className="p-4 border rounded-xl bg-indigo-50">

        {item.type === "structured" ? (
          <>
            <div className="font-semibold text-indigo-700">
              {item.issue}
            </div>
            <div className="text-sm text-gray-700 mt-1">
              {item.suggestion}
            </div>
          </>
        ) : (
          <div className="text-sm text-gray-700">
            {item.issue}
          </div>
        )}

      </div>
    ))}
  </div>
</div>

</div>
        </div>
      )}

    </div>
  </div>
)}

    </PageWrapper>
  );
}